import { getGalleryConfig } from "@/data/portfolioGalleryRegistry";
import PortfolioCategoryPlaceholder from "./PortfolioCategoryPlaceholder";
import PortfolioScreenshotGallery from "./PortfolioScreenshotGallery";

export default function CategoryPortfolioGallery({ categoryId, embed = false, onActiveChange }) {
  const config = getGalleryConfig(categoryId);
  if (!config) return null;

  if (!config.images.length) {
    return (
      <PortfolioCategoryPlaceholder
        config={config}
        embed={embed}
        onActiveChange={onActiveChange}
      />
    );
  }

  return (
    <PortfolioScreenshotGallery
      embed={embed}
      onActiveChange={onActiveChange}
      images={config.images}
      accent={config.accent}
      testId={config.testId}
      ariaLabel={config.ariaLabel}
      panelPrefix={config.panelPrefix}
    />
  );
}
